/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `allClasses` - Wszystkie klasy
 * * `selectedSchools` - Wybrane szkoły
 * * `selectedClasses` - Wybrane klasy
 */
export type QuizPushQuizScopeKindEnum = typeof QuizPushQuizScopeKindEnum[keyof typeof QuizPushQuizScopeKindEnum];


export const QuizPushQuizScopeKindEnum = {
  allClasses: 'allClasses',
  selectedSchools: 'selectedSchools',
  selectedClasses: 'selectedClasses',
} as const;
